import { create } from 'zustand';

import { createBoardActions } from './boardStore/boardActions';
import { createIdeaActions } from './boardStore/ideaActions';
import { createSocketActions } from './boardStore/socketActions';
import type { BoardState } from './boardStore/types';

const useBoardStore = create<BoardState>((set, get) => ({
  boardId: null,
  ideas: [],
  participants: [],
  chat: [],
  boardDetails: null,
  viewCard: null,
  isLoadingBoard: false,
  boardLoadError: null,
  actionError: null,
  showVoteOwners: false,
  ...createBoardActions(set, get),
  ...createIdeaActions(set, get),
  ...createSocketActions(set, get),
}));

export default useBoardStore;
